import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { InstallationItem, InstallationItemGatewayDevice } from '@vi-iot/client';

import { AppState } from '@store';

import { MapState } from './map.state';

export namespace MapSelectors {
  export const mapState = (state: AppState): MapState => state.map;

  export function getState(): MemoizedSelector<AppState, MapState, DefaultProjectorFn<MapState>> {
    return createSelector(mapState, (state: MapState) => state);
  }

  export function getInstallations(): MemoizedSelector<
    AppState,
    InstallationItem[],
    DefaultProjectorFn<InstallationItem[]>
  > {
    return createSelector(mapState, (state: MapState) => state.installations);
  }

  export function getMapCenter(): MemoizedSelector<
    AppState,
    { lat: number; lng: number },
    DefaultProjectorFn<{ lat: number; lng: number }>
  > {
    return createSelector(mapState, (state: MapState) => {
      return {
        lat: state.latitude,
        lng: state.longitude,
      };
    });
  }

  // get main devices from each gateway
  export function getInstallationMainDevices(
    installationId: number
  ): MemoizedSelector<
    AppState,
    InstallationItemGatewayDevice[],
    DefaultProjectorFn<InstallationItemGatewayDevice[]>
  > {
    return createSelector(mapState, (state: MapState) =>
      state.installations
        .find((installation) => installation.id === installationId)
        ?.gateways.map((gateway) => gateway.devices.find((device) => device.id === '0'))
    );
  }
}
